<template src="./index.html">
</template>

<script>
	import {getdata} from "./data.js";
	import minhead from '../../../../common/minHead/index.vue'
	export default {
		components:{
			minhead
		},
		props: {
			tableData:{
				type: Array,
				default: getdata().tableData
			}
		},	
		data() {
			return {
				headData:getdata().headData,
				delCells:[],
			}
		},
		created() {
			if(this.$emptyandnull(this.tableData)){
				this.tableData=getdata().tableData
			}
		},
		mounted() {
		
		},
		methods: {
			forsave(){
				this.$emit("getdetaildata",this.tableData)
			},
			getTatol(key){
				let total=0
				this.tableData.forEach((item,index)=>{
					if(index!=this.tableData.length-1){
						total+=parseFloat(item[key]||0) 
					}
				})
				return total
			},
			//返回
			forback(){
				this.$emit('forback',false)
			},
			//删除行
			fordelete(index) {
			    if (this.tableData.length < 3) {
			        return false;
			    }
			    if (this.$notemptyandnull()) {
			        this.delCells.push(JSON.parse(JSON.stringify(this.tableData[index])));
			    }
			    this.tableData.splice(index, 1);
			},
			//添加行
			foraddhang() {
			    let endobj = this.tableData[this.tableData.length - 1];
			    this.tableData.pop();
			    this.tableData.push({
					Serial:'',
					Details:'',
					AmountA:'',
					TaxAmount:'',
					TaxAdjustment:'',
					DisposalIRBA:'',
					DisposalICBT:'',
					BookVDI:'',
					TaxDasisDI:'',
					DisposalDILRA:'',
					DisposalDITC:'',
					TaxAamount:'',
					AdjustmentA:'',
				});
			    this.tableData.push(endobj);
			}
		}
	};
</script>

<style scoped lang="less">
	@import url('index.less');
</style>
